import type { ReactNode } from "react";
import { useEffect, useState } from "react";

import { cn } from "@/lib/utils";

import type { TabId } from "./TabNavigation";

type TabPanelProps = {
  tabId: TabId;
  activeTab: TabId;
  children: ReactNode;
  mountMode?: "eager" | "lazy";
};

export function TabPanel({
  tabId,
  activeTab,
  children,
  mountMode = "eager",
}: TabPanelProps) {
  const isActive = tabId === activeTab;
  const [hasBeenActive, setHasBeenActive] = useState(isActive);

  useEffect(() => {
    if (isActive) {
      setHasBeenActive(true);
    }
  }, [isActive]);

  if (mountMode === "lazy" && !hasBeenActive) {
    return null;
  }

  return (
    <section
      role="tabpanel"
      id={`panel-${tabId}`}
      aria-labelledby={`tab-${tabId}`}
      className={cn("tab-panel", isActive ? "block" : "hidden")}
      hidden={!isActive}
    >
      {children}
    </section>
  );
}
